const translations = {
  fr: {
    nav: {
      home: "Accueil",
      services: "Services",
      gallery: "Galerie",
      about: "À propos",
      contact: "Contact",
    },

    hero: {
      title: "Barber Lounes",
      subtitle: "Style propre. Coupe parfaite.",
      button: "Voir nos services",
    },

    services: {
      title: "Services",
      reserve: "Réserver",
      items: [
        {
          title: "Coupe",
          desc: "Coupe moderne adaptée à votre style",
          price: "50$",
        },
        {
          title: "Buzz Cut",
          desc: "Coupe très courte et uniforme, style net et facile à entretenir",
          price: "50$",
        },
        {
          title: "Coupe Espagnole",
          desc: "Dégradé propre avec un style moderne inspiré des tendances espagnoles",
          price: "50$",
        },
        {
          title: "Fade",
          desc: "Dégradé propre et précis",
          price: "50$",
        },
      ],
    },

    about: {
      title: "À propos",
      text1:
        "Barber Lounes est un salon situé au centre-ville de Montréal, au 215 rue Milton.",
      text2: "Nous proposons des coupes modernes et un service personnalisé.",
      text3:
        "Notre objectif est de vous offrir un style propre et professionnel.",
    },

    contact: {
      title: "Contact",
      address: "214 rue Milton, Montréal",
      phone: "438 763 9625",
    },
  },

  en: {
    nav: {
      home: "Home",
      services: "Services",
      gallery: "Gallery",
      about: "About",
      contact: "Contact",
    },

    hero: {
      title: "Barber Lounes",
      subtitle: "Clean style. Perfect cut.",
      button: "View our services",
    },

    services: {
      title: "Services",
      reserve: "Book Now",
      items: [
        {
          title: "Haircut",
          desc: "Modern haircut adapted to your style",
          price: "50$",
        },
        {
          title: "Buzz Cut",
          desc: "Very short and even haircut, clean style and easy to maintain",
          price: "50$",
        },
        {
          title: "Spanish Cut",
          desc: "Clean fade with a modern style inspired by Spanish trends",
          price: "50$",
        },
        {
          title: "Fade",
          desc: "Clean and precise fade",
          price: "50$",
        },
      ],
    },

    about: {
      title: "About",
      text1:
        "Barber Lounes is a barbershop located in downtown Montreal at 215 Milton Street.",
      text2: "We offer modern haircuts and personalized service.",
      text3: "Our goal is to provide a clean and professional style.",
    },

    contact: {
      title: "Contact",
      address: "214 Milton Street, Montreal",
      phone: "438 763 9625",
    },
  },
};

export default translations;
